
export default {
    name: 'historique-motif-consultation',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}


